import { normalizeSiblingNavPath } from './siblingFileNavigation';

const STORAGE_PREFIX = 'revisdom:folderBrowseList:';

export type FolderBrowseFileRef = {
  id: number;
  path: string;
  name?: string | null;
  entryType?: string | number | null;
};

export type FolderFileBrowseSnapshot = {
  parentKey: string;
  updatedAt: number;
  files: FolderBrowseFileRef[];
  sortField?: string;
  sortDirection?: string;
  filterDateType?: string;
  filterOrganization?: string;
  filterName?: string;
};

export function folderBrowseParentKey(rawPath: string): string {
  return normalizeSiblingNavPath(rawPath);
}

function storageKey(parentKey: string): string {
  return `${STORAGE_PREFIX}${folderBrowseParentKey(parentKey)}`;
}

export function saveFolderFileBrowseList(
  parentPath: string,
  snapshot: Omit<FolderFileBrowseSnapshot, 'parentKey' | 'updatedAt'> & {
    files: FolderBrowseFileRef[];
  }
): void {
  if (typeof sessionStorage === 'undefined') return;
  const parentKey = folderBrowseParentKey(parentPath);
  if (!parentKey) return;

  const payload: FolderFileBrowseSnapshot = {
    parentKey,
    updatedAt: Date.now(),
    ...snapshot,
  };

  try {
    sessionStorage.setItem(storageKey(parentKey), JSON.stringify(payload));
  } catch {
    /* quota / private mode */
  }
}

export function readFolderFileBrowseList(
  parentPath: string | null | undefined
): FolderFileBrowseSnapshot | null {
  if (typeof sessionStorage === 'undefined') return null;
  const parentKey = folderBrowseParentKey(String(parentPath ?? ''));
  if (!parentKey) return null;

  try {
    const raw = sessionStorage.getItem(storageKey(parentKey));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as FolderFileBrowseSnapshot;
    if (!parsed || parsed.parentKey !== parentKey || !Array.isArray(parsed.files)) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

/** Mevcut dosya listede yoksa (doğrudan URL vb.) cache kullanılmaz. */
export function readFolderFileBrowseListForCurrentFile(
  parentPath: string | null | undefined,
  currentFilePath: string | null | undefined
): FolderBrowseFileRef[] | null {
  const snapshot = readFolderFileBrowseList(parentPath);
  if (!snapshot?.files.length) return null;

  const currentKey = normalizeSiblingNavPath(String(currentFilePath ?? ''));
  if (!currentKey) return null;

  const inList = snapshot.files.some(
    (f) => normalizeSiblingNavPath(String(f.path ?? '')) === currentKey
  );
  if (!inList) return null;

  return snapshot.files;
}
